module.exports = __webpack_public_path__ + "static/media/green6.ad33a8e8.jpg";